export const getDisplayAmount = (
  amount: bigint,
  memberCount: boolean,
): string => {
  const divisor = memberCount ? 1n : 1000000n;
  return Number(amount / divisor).toLocaleString('en-US');
};
